<template src="./template.html"></template>
<script>
export default {
  name: 'PageHeading',
  props: ['pageTitle', 'pageText'],
};
</script>



// WEBPACK FOOTER //
// src/components/modules/03_page_heading/index.vue